import {TFunction} from "i18next";
import {MUIDataTableColumn, MUIDataTableMeta} from "mui-datatables";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {Application, translationsComplete} from "./Application";

export function applicationsTableColumns(t: TFunction, smallScreens: boolean): MUIDataTableColumn[] {
  return [
    {name: 'id', label: t('Application.id'), options: {filter: false}},
    {name: 'name', label: t('Application.name'), options: {filter: false}},
    {name: 'keycloakClientId', label: t('Application.keycloakClientId'), options: {filter: false, display: !smallScreens}},
    {name: 'url', label: t('Application.url'), options: {filter: false, display: !smallScreens}},
    {
      name: 'displayNames',
      label: t('Application.displayNames.title'),
      options: {filter: false, display: !smallScreens, customBodyRender: TranslationCheckbox}
    },
  ];
}

function TranslationCheckbox(value: any, tableMeta: MUIDataTableMeta) {
  const application: Application = tableMeta.tableData[tableMeta.rowIndex] as any as Application;
  if (!translationsComplete(application)) {
    return <div style={{marginLeft: "auto", marginRight: "auto", width: "fit-content"}}><CancelIcon style={{color: "orange"}}/></div>
  } else {
    return <div style={{marginLeft: "auto", marginRight: "auto", width: "fit-content"}}><CheckCircleIcon style={{color: "green"}}/></div>
  }
}
